__turbopack_context__.v({
  "boardsDesktop": "BoardsMenu-module__3P4ogG__boardsDesktop",
  "boardsMobile": "BoardsMenu-module__3P4ogG__boardsMobile",
  "boardsVisible": "BoardsMenu-module__3P4ogG__boardsVisible",
  "container": "BoardsMenu-module__3P4ogG__container",
  "dropdownBtn": "BoardsMenu-module__3P4ogG__dropdownBtn",
  "dropdownBtnExpanded": "BoardsMenu-module__3P4ogG__dropdownBtnExpanded",
  "fadeInItems": "BoardsMenu-module__3P4ogG__fadeInItems",
  "inTownToggle": "BoardsMenu-module__3P4ogG__inTownToggle",
  "link": "BoardsMenu-module__3P4ogG__link",
  "linkActive": "BoardsMenu-module__3P4ogG__linkActive",
  "spacing--lg": "BoardsMenu-module__3P4ogG__spacing--lg",
  "spacing--md": "BoardsMenu-module__3P4ogG__spacing--md",
  "spacing--sm": "BoardsMenu-module__3P4ogG__spacing--sm",
  "spacing--xl": "BoardsMenu-module__3P4ogG__spacing--xl",
  "spacing--xs": "BoardsMenu-module__3P4ogG__spacing--xs",
  "spacing--xxl": "BoardsMenu-module__3P4ogG__spacing--xxl",
  "spacing--xxs": "BoardsMenu-module__3P4ogG__spacing--xxs",
  "spacing--xxxl": "BoardsMenu-module__3P4ogG__spacing--xxxl",
  "spacing--xxxs": "BoardsMenu-module__3P4ogG__spacing--xxxs",
  "toggle": "BoardsMenu-module__3P4ogG__toggle",
});
